module.exports = __webpack_public_path__ + "img/agency_banner_5.1048e232.png";